import React, {useEffect, useRef} from 'react';
import {useSelector} from "react-redux";
import useAsyncErrorHandler from "./useAsyncErrorHandler";
import useLoading from "./useLoading";
import * as Async from "../features/async";

export default function useFetch() {
    const isMounted = useRef(true);
    const setLoading = useLoading();
    const asyncErrorHandler = useAsyncErrorHandler();
    const credencial = useSelector(state => state.credencial);

    useEffect(() => {
        isMounted.current = true;

        return () => (isMounted.current = false);
    }, []);

    return (url, params, onSuccess, onError, shouldFinishLoading = true) => {
        if (typeof onError === 'boolean') {
            shouldFinishLoading = onError;

            onError = undefined;
        }

        setLoading(true);

        return Async.fetch(url, credencial, params)
            .then(data => {
                if (isMounted.current) {
                    onSuccess && onSuccess(data);

                    return data;
                }
            })
            .catch(error => {
                onError ? onError(error, asyncErrorHandler) : asyncErrorHandler(error);
            })
            .finally(() => shouldFinishLoading && setLoading(false));
    };
}